// extracted by css-extract-rspack-plugin
export default {"checkoutHeader":"header-fragment__CheckoutHeader_checkoutHeader__7AsYm","checkoutHeaderInfoSection":"header-fragment__CheckoutHeader_checkoutHeaderInfoSection__JcyUs"};